import {ERROR_ACTIONS} from "./types";

export const addError = message => ({type: ERROR_ACTIONS.ADD, message});
export const dismissError = () => ({type: ERROR_ACTIONS.DISMISS});
export const clearAllErrors = () => ({type: ERROR_ACTIONS.CLEAR_ALL});


// WEBPACK FOOTER //
// ./src/actions/errorActions.js